import {
	BaseAPIResponse,
	ContestTemplateFilterInputs,
	GetAllTimeLeaderboardAPIResponse,
	GetUIContestByIdAPIResponse,
	GetUIContestsAPIResponse,
} from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/contest`;

export const getContestsQuery = async (payload?: ContestTemplateFilterInputs): Promise<GetUIContestsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/sellable`, { params: payload });
	return response.data;
};

export const getAllTimeLeaderboardQuery = async (): Promise<GetAllTimeLeaderboardAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/all-time-leaderboard`);
	return response.data;
};

export const getContestById = async ({
	id,
	payload,
}: {
	id: string;
	payload?: ContestTemplateFilterInputs;
}): Promise<GetUIContestByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/sellable/${id}`, { params: payload });
	return response.data;
};

export const registerForContest = async ({ contestId }: { contestId: string }): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/register-for-contest`, { contestId });
	return response.data;
};

export const startContest = async ({
	contestId,
}: {
	contestId: string;
}): Promise<BaseAPIResponse & { contestToken: string }> => {
	const response = await baseApi.post(`${baseUrl}/start-contest`, { contestId });
	return response.data;
};
